export const SWITCH_THREAD = 'SWITCH_THREAD'
export const RECEIVE_ALL = 'RECEIVE_ALL'
export const RECEIVE_MESSAGE = 'RECEIVE_MESSAGE'
export const REALNAME_MESSAGE = 'REALNAME_MESSAGE'
export const REALNAME_VERIFY_STATUS = 'REALNAME_VERIFY_STATUS'
export const REALNAME_USER_INFO = 'REALNAME_USER_INFO'
export const USER_HAS_REAL_NAME = 'USER_HAS_REAL_NAME'
export const VERIFIED_LIST = 'VERIFIED_LIST'
export const REALNAME_VERIFING = 'REALNAME_VERIFING'
export const REALNAME_VERIFY_INFO = 'REALNAME_VERIFY_INFO'
export const QUERY = 'QUERY'
export const CELLID = 'CELLID'
export const ORDERS = 'ORDERS'
export const ROLEID = 'ROLEID'
export const UNVERIFIED = 'UNVERIFIED'
export const ENV = 'ENV'
export const TICKET = 'TICKET'
export const CELL = 'CELL'
export const TRINITY_COLLECT_REASON = 'TRINITY_COLLECT_REASON'
export const AUTH_STATE = 'AUTH_STATE'
